/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ValidateDeliveryDistanceReason } from './ValidateDeliveryDistanceReason';
import {
    ValidateDeliveryDistanceReasonFromJSON,
    ValidateDeliveryDistanceReasonFromJSONTyped,
    ValidateDeliveryDistanceReasonToJSON,
    ValidateDeliveryDistanceReasonToJSONTyped,
} from './ValidateDeliveryDistanceReason';

/**
 * Represents the response when validating if an address is close enough to a merchant to order delivery.
 * @export
 * @interface ValidateDeliveryDistanceResponse
 */
export interface ValidateDeliveryDistanceResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidateDeliveryDistanceResponse
     */
    canDeliver: boolean;
    /**
     * 
     * @type {ValidateDeliveryDistanceReason}
     * @memberof ValidateDeliveryDistanceResponse
     */
    reason?: ValidateDeliveryDistanceReason;
}



/**
 * Check if a given object implements the ValidateDeliveryDistanceResponse interface.
 */
export function instanceOfValidateDeliveryDistanceResponse(value: object): value is ValidateDeliveryDistanceResponse {
    if (!('canDeliver' in value) || value['canDeliver'] === undefined) return false;
    return true;
}

export function ValidateDeliveryDistanceResponseFromJSON(json: any): ValidateDeliveryDistanceResponse {
    return ValidateDeliveryDistanceResponseFromJSONTyped(json, false);
}

export function ValidateDeliveryDistanceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateDeliveryDistanceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'canDeliver': json['canDeliver'],
        'reason': json['reason'] == null ? undefined : ValidateDeliveryDistanceReasonFromJSON(json['reason']),
    };
}

export function ValidateDeliveryDistanceResponseToJSON(json: any): ValidateDeliveryDistanceResponse {
    return ValidateDeliveryDistanceResponseToJSONTyped(json, false);
}

export function ValidateDeliveryDistanceResponseToJSONTyped(value?: ValidateDeliveryDistanceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'canDeliver': value['canDeliver'],
        'reason': ValidateDeliveryDistanceReasonToJSON(value['reason']),
    };
}

